import { sleep } from '~/shared';

export async function loadCompleteScreenshot(
	filename: string,
	signal: AbortSignal,
): Promise<Blob> {
	let stableSize: number | undefined;
	let reason = 'File not ready';

	while (!signal.aborted) {
		try {
			const response = await fetch(`http://screenshots/${filename}`, {
				cache: 'no-store',
				signal,
			});
			if (!response.ok) throw new Error(`HTTP ${response.status}`);
			const blob = await response.blob();
			if (!blob.size || !blob.type.startsWith('image/')) {
				throw new Error(
					`Empty or invalid image: ${blob.size} bytes, ${blob.type}`,
				);
			}
			const image = await createImageBitmap(blob);
			image.close();
			if (stableSize === blob.size && !signal.aborted) return blob;
			stableSize = blob.size;
			reason = `Image is still being written: ${blob.size} bytes`;
		} catch (error) {
			if (signal.aborted) break;
			stableSize = undefined;
			reason = String(error);
		}

		if (!signal.aborted) await sleep(250);
	}

	throw new Error(reason);
}
